import React, { useEffect, useState } from 'react';
import { Icon } from '@appd/uik';

export interface IconCellRendererProps {
  value: string;
  type: string;
  size: 'LARGE' | 'MEDIUM' | 'SMALL' | 'XLARGE' | undefined;
  clickFn?: () => {};
}

/**
 * This component renders a horizontally centered icon with a click function
 */
const IconCellRenderer = (props: any): JSX.Element => {
  const [iconType, setIconType] = useState('');

  useEffect(() => {
    if (typeof props.type === 'function') {
      props.type(props).then((res: string) => {
        setIconType(res);
      });
    } else if (typeof props.type === 'string') {
      setIconType(props.type);
    } else {
      setIconType('Status.Unknown');
    }
  });

  return (
    <div className="flex text-center justify-center hover:cursor-pointer">
      <Icon
        data-key={props.value}
        type={iconType}
        size={props.size}
        onClick={e => {
          props.clickFn(e, props.row);
        }}
      />
    </div>
  );
};

export { IconCellRenderer };
